/*
  Functions for syncronizing the theme1.unuse() and theme2.use() calls.
    
  This helps smoothen the transition when changing
  from theme1 to theme2
*/

let _onUse: () => any = null;
let _onUnuse: () => any = null;

export const unuseCSs = (onUnuse: () => any) => {
  _onUnuse = onUnuse;
  check();
};

let _firstTime = true;
export const useCss = (onUse: () => any) => {
  if (_firstTime) {
    _firstTime = false;
    onUse();
    return;
  }

  _onUse = onUse;
  check();
};

const check = () => {
  if (_onUse && _onUnuse) {
    _onUse();
    _onUnuse();

    /*    const targetNode = document.head;

    const config = { childList: true };

    let __onUnuse = _onUnuse;
    const callback = function (mutationsList, observer) {
      observer.disconnect();
      __onUnuse();
      __onUnuse = null;
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config); */

    _onUse = null;
    _onUnuse = null;
  }
};
